import { render, staticRenderFns } from "./PermissionShowcase.vue?vue&type=template&id=4b6bc6d4&scoped=true&"
import script from "./PermissionShowcase.vue?vue&type=script&lang=js&"
export * from "./PermissionShowcase.vue?vue&type=script&lang=js&"
import style0 from "./PermissionShowcase.vue?vue&type=style&index=0&id=4b6bc6d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bc6d4",
  null
  
)

export default component.exports